export default __webpack_public_path__ + "static/media/golf-per-tutti.e154c677.png";